import { useEffectReducer } from 'use-effect-reducer'
import { getCnpPmofSessionPaymentEffectsMap } from './effects'
import { cnpPmofPaymentStateReducer } from './reducer'
import {
  LSPAYCnpPmofPaymentState,
  LSPAYCnpPmofPaymentEffectsMapArgs,
} from './types'

export const useCnpPmofSessionEffectReducer = (
  args: LSPAYCnpPmofPaymentEffectsMapArgs
) => {
  return useEffectReducer(
    cnpPmofPaymentStateReducer,
    // this starts the state machine
    exec => {
      exec({
        type: 'createSessionEffect',
      })
      const initialState: LSPAYCnpPmofPaymentState = {
        status: 'creatingSession',
      }
      return initialState
    },
    getCnpPmofSessionPaymentEffectsMap({ ...args })
  )
}
